import { lazy } from 'solid-js'
import { platform } from '../../../../.configs/app/environment.js'
import { messages } from '../../pages/lodgr-insights-app-page/lodgr-insights-app-page-routing.messages.en.js'

/*
    TENANT-5565. The mobile app's Lodgr Insights page. App builds only: the
    website keeps /lodgr-insights (the conference page) and never routes this
    path — `null` is what the router's filter drops, the same switch
    `test-page-routing.js` uses for environment-only routes. Not in
    `sitemap-routes.js`; `noIndex` for the one case a crawler meets it.
*/
export default platform.isMobileApp
    ? {
        component: lazy(() => import('../../pages/lodgr-insights-app-page/lodgr-insights-app-page.jsx')),
        descriptionMessage: messages.descriptionMessage,
        noIndex: true,
        path: '/insights',
        showFooter: false,
        titleMessage: messages.titleMessage,
    }
    // eslint-disable-next-line unicorn/no-null -- router.jsx filters `route !== null`; undefined would register the route
    : null
